export const setRequestNewAddressChild =
  (setRequestNewAddress) => (childData) => {
    setRequestNewAddress(childData);
  };

export const setDelAddress1Child = (setDelAddress1) => (childData) => {
  setDelAddress1(childData);
};

export const setDelAddress2Child = (setDelAddress2) => (childData) => {
  setDelAddress2(childData);
};

export const setDelAddress3Child = (setDelAddress3) => (childData) => {
  setDelAddress3(childData);
};

export const setDelAddress4Child = (setDelAddress4) => (childData) => {
  setDelAddress4(childData);
};

export const setDelPostalCodeChild = (setDelPostalCode) => (childData) => {
  setDelPostalCode(childData);
};

export const SetDefaultDeliveryChild = (SetDefaultDelivery) => (childData) => {
  SetDefaultDelivery(childData);
};

export const setInvoiceAddressChild = (setPostId) => (childData) => {
  setPostId(childData);
};

export const setCustomerIdChild = (setCustomerId) => (childData) => {
  setCustomerId(childData);
};

export const setSelectedDeliveryChild =
  (setSelectedDelivery) => (childData) => {
    setSelectedDelivery(childData);
  };

export const setSelectedCarriersChild =
  (setSelectedCarriers) => (childData) => {
    setSelectedCarriers(childData);
  };

export const setSelectedFreightTermsChild =
  (setSelectedFreightTerms) => (childData) => {
    setSelectedFreightTerms(childData);
  };

export const setCustPoNumberChild = (setCustPoNumber) => (childData) => {
  setCustPoNumber(childData);
};

export const setSamplingAndPackagingCodeChild =
  (setSamplingAndPackagingCode) => (childData) => {
    setSamplingAndPackagingCode(childData);
  };

export const setLayoutApprovalChild = (setLayoutApproval) => (childData) => {
  setLayoutApproval(childData);
};

export const setOrderOnHoldChild = (setOrderOnHold) => (childData) => {
  setOrderOnHold(childData);
};

export const setCheckDuplicatePOChild =
  (setCheckDuplicatePO) => (childData) => {
    setCheckDuplicatePO(childData);
  };

export const setCheckedChild =
  (setchecked, setCheckCollector) => (childData) => {
    setchecked(childData);
    setCheckCollector(childData);
  };

export const CollectorNameChild = (setCollectorName) => (childData) => {
  setCollectorName(childData);
};

export const setDelCustomerNameChild = (setDelCustomerName) => (childData) => {
  setDelCustomerName(childData);
};

export const setDelContactNameChild = (setDelContactName) => (childData) => {
  setDelContactName(childData);
};

export const setDelCountryCodeChild = (SetDeLCountry) => (childData) => {
  SetDeLCountry(childData);
};
